import { api } from "./client";
import type {
  ApiResponse,
  InterestsResponse,
  InterestType,
  MyProposalsResponse,
  ProposeInterestRequest,
  ProposeInterestResponse,
  RefInterest,
} from "./types";

/**
 * Phase 13.6 — Custom interest proposals
 */
export function proposeInterest(data: ProposeInterestRequest) {
  return api.post<ApiResponse<ProposeInterestResponse>>(
    "/interests/propose",
    data,
  );
}

export function getMyProposals(params?: {
  status?: "pending" | "approved" | "rejected";
  limit?: number;
  offset?: number;
}) {
  return api.get<ApiResponse<MyProposalsResponse>>(
    "/interests/my-proposals",
    params,
  );
}

/**
 * Existing endpoints (typed wrappers for ergonomics)
 */
export function searchInterests(params: {
  q: string;
  category?: string;
  limit?: number;
}) {
  return api.get<
    ApiResponse<{ items: RefInterest[]; query: string; count: number }>
  >("/interests/search", params);
}

export function listInterestsByCategory(
  category: string,
  params?: { limit?: number },
) {
  return api.get<ApiResponse<InterestsResponse>>("/interests", {
    category,
    ...params,
  });
}

export function listInterestsByType(
  type: InterestType,
  params?: { limit?: number },
) {
  return api.get<ApiResponse<InterestsResponse>>("/interests", {
    type,
    ...params,
  });
}

/**
 * GET /interests/for-state/{code}: one state's round. With a decade ("90s"),
 * or signed in with a decade on the board, that decade's items come first.
 */
export interface InterestsForState {
  stateCode: string;
  decade: string | null;
  items: RefInterest[];
  byCategory: Record<string, RefInterest[]>;
  count: number;
}

export function getInterestsForState(stateCode: string, decade?: string) {
  return api.get<ApiResponse<InterestsForState>>(
    `/interests/for-state/${encodeURIComponent(stateCode)}`,
    decade ? { decade } : undefined,
  );
}
